module.exports = __webpack_public_path__ + "img/valorant.04e02c9b.png";